import { http } from '@/utils'

/*
 * cms配置招聘信息
 */
export async function getTrackCmsConfig() {
  try {
    const res: any = await http.get(
      '//cms.cekid.com/publish/997/config/EHRTrackSettings.json'
    )
    if (res.code === 0) {
      return res.data
    } else {
      return Promise.reject()
    }
  } catch (e) {
    return Promise.reject()
  }
}
